import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LocalRegistrationPageBase } from '../../shared/local-registration-page-base';

@Component({
	selector: 'app-registration-already-registered-page',
	imports: [TranslocoDirective],
	templateUrl: './registration-already-registered-page.html'
})
export class RegistrationAlreadyRegisteredPage extends LocalRegistrationPageBase {}
